import * as yup from 'yup';

export const numberValidation = yup
  .string()
  .required(`This field is required`)
  .test(
    'is-number',
    'Invalid Number',
    (value): any => value && value.replace(/,/g, '').match(/^-?\d+$/),
  )
  .test(
    'is-positive',
    'Needs to be greater than zero',
    (value) => value && Number.parseFloat(value.replace(/,/g, '')) > 0,
  );

export const floatValidation = yup
  .string()
  .required(`This field is required`)
  .test(
    'is-number',
    'Invalid Number',
    (value) => value && !isNaN(value.replace(/,/g, '') as any),
  )
  .test(
    'is-positive',
    'Needs to be greater than zero',
    (value) => value && Number.parseFloat(value.replace(/,/g, '')) > 0,
  );

export const asinValidation = (isAmazonSeller: boolean) =>
  yup
    .string()
    .test(
      'valid-length',
      'Invalid ASIN. ASIN must be 10 characters.',
      (value) => !isAmazonSeller || (value && value.length === 10),
    );

const URL =
  /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/;

export const urlValidation = yup.string().matches(URL, 'Enter a valid URL');
